module.exports = __webpack_public_path__ + "static/media/profile-pic.960e902b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-pic.png
// module id = 716
// module chunks = 0